// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7610e0ac","703":"a8647fdc"}[chunkId] + ".chunk.js";
};